import { GET_SOPS_DOCUMENT } from "../../constants/api";
import { ConfluencePage, TableRowData } from "../../types/dataType";
import axios from "../fetch/fetch";

export const getSOPsDocumentAPI = async (): Promise<TableRowData[]> => {
    const res = await axios.get(GET_SOPS_DOCUMENT);
    return res.data;
};
